<!-- Секция тарифов - Organism -->
<template>
  <section class="bg-black relative overflow-hidden md:min-h-[880px] py-16">
    <!-- Фоновые элементы -->
    <div class="absolute inset-0">
      <div class="absolute inset-0 bg-[rgba(22,22,22,0.33)]" />
    </div>

    <!-- Заголовок и тарифы в одном контейнере -->
    <div class="relative z-10 mx-auto max-w-7xl px-6">
      <h2
        class="text-center text-[76.319px] md:text-[170px] font-['Halvar_Breitschrift'] font-medium leading-[100%] mb-0 bg-gradient-to-r from-white via-white to-transparent bg-clip-text">
        Тарифы
      </h2>

      <!-- Тарифные планы с transform -->
      <div class="pricing-cards-container relative z-20">
        <div class="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          <div ref="pricingCard1" :style="revealStyles1"
            :class="['pricing-card', `reveal-${direction1}`, { 'is-visible': isVisible1 }]"
            class="backdrop-blur-[30px] bg-[url('/images/block/tariffs/one.png')] bg-cover bg-center bg-no-repeat bg-black/70 rounded-[25px] p-8 relative overflow-hidden max-w-[550px] min-h-[552px] mx-auto w-full shadow-[inset_0_6px_16px_rgba(255,255,255,0.26)] flex flex-col">
            <div class="relative z-10 flex-1">
              <BaseHeading :level="3" class="text-2xl font-bold text-center mb-8">
                Touch One
              </BaseHeading>

              <div class="mb-8">
                <div class="price-container flex items-end mb-2">
                  <span class="price-strikethrough text-lg text-gray-400 line-through">1.500₽</span>
                  <span class="price-main font-medium text-4xl text-gradient">
                    500₽
                  </span>
                  <span class="price-period text-xl text-white/80 whitespace-nowrap">/ первый месяц</span>
                </div>
              </div>

              <!-- Разделитель -->
              <hr class="border-white/25 mb-8" />

              <!-- Особенности -->
              <div>
                <ul class="space-y-[12px]">
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Доступ к приложению</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Личный аккаунт</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Безлимитная загрузка треков</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">95% роялти</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Личный менеджер</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Все возможности TOUCH</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Кнопки - прижаты к низу -->
            <div class="buttons-container relative z-10 flex justify-start items-end gap-[12px]">
              <!-- Черная кнопка -->
              <div>
                <BaseButton tone="black" size="figma" :show-arrow="true">
                  Touch One на месяц
                </BaseButton>
              </div>

              <!-- Белая кнопка с бейджем -->
              <div class="relative">
                <div
                  class="button-badge absolute -top-3 right-8 w-[144px] h-[23px] flex items-center justify-center rotate-45text-white text-[8px] leading-none rounded-[26px] whitespace-nowrap uppercase z-10"
                  style="background: linear-gradient(180deg, #000000 0%, #97D6DF 230.43%);">
                  +2 месяца в подарок
                </div>
                <BaseButton tone="white" size="figma" :show-arrow="true">
                  Touch One на год
                </BaseButton>
              </div>
            </div>
          </div>

          <!-- Touch Multi -->
          <div ref="pricingCard2" :style="revealStyles2"
            :class="['pricing-card', `reveal-${direction2}`, { 'is-visible': isVisible2 }]"
            class="backdrop-blur-[15px] bg-[url('/images/block/tariffs/multi.png')] bg-cover bg-center bg-no-repeat bg-gradient-to-t from-[rgba(151,214,223,0.04)] to-[rgba(151,214,223,0.04)] bg-black/70 rounded-[25px] p-8 relative overflow-hidden max-w-[550px] min-h-[522px] mx-auto w-full shadow-[inset_0_6px_16px_rgba(255,255,255,0.26)] flex flex-col">

            <div class="relative z-10 flex-1">
              <!-- Заголовок тарифа -->
              <BaseHeading :level="3" class="text-2xl font-bold text-white mb-8">
                Touch Multi (Label Edition)
              </BaseHeading>

              <!-- Цена -->
              <div class="price-container flex items-end mb-8">
                <span class="price-main text-4xl font-medium text-white">
                  4.900₽
                </span>
                <span class="price-period text-xl text-white/50 whitespace-nowrap">/мес</span>
              </div>

              <!-- Разделитель -->
              <hr class="border-white/25 mb-8" />

              <!-- Особенности -->
              <div>
                <ul class="space-y-[12px]">
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Доступ к приложению</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Аккаунт лейбла</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Безлимитная загрузка треков</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">95% роялти</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Поддержка 24/7</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Доступ к партнёрским студиям TOUCH</span>
                  </li>
                  <li class="flex items-center gap-3">
                    <img src="/images/check-icon.svg" alt="" style="width: 1.5rem; height: 1.5rem;" />
                    <span class="text-white">Все возможности TOUCH</span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Кнопки - прижаты к низу -->
            <div class="buttons-container relative z-10 flex justify-start items-end gap-[12px]">
              <!-- Черная кнопка -->
              <div>
                <BaseButton tone="black" size="figma" :show-arrow="true">
                  Touch Multi на месяц
                </BaseButton>
              </div>

              <!-- Белая кнопка с бейджем -->
              <div class="relative">
                <div
                  class="button-badge absolute -top-3 right-8 w-[144px] h-[23px] flex items-center justify-center rotate-45text-white text-[8px] leading-none rounded-[26px] whitespace-nowrap uppercase z-10"
                  style="background: linear-gradient(180deg, #000000 0%, #97D6DF 230.43%);">
                  +2 месяца в подарок
                </div>
                <BaseButton tone="white" size="figma" :show-arrow="true">
                  Touch Multi на год
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import BaseHeading from '@/components/atoms/BaseHeading.vue'
import BaseButton from '@/components/atoms/BaseButton.vue'
import { useScrollReveal } from '@/composables/useScrollReveal'

// Анимация для первой карточки (Touch One)
const {
  elementRef: pricingCard1,
  isVisible: isVisible1,
  revealStyles: revealStyles1,
  direction: direction1
} = useScrollReveal({
  direction: 'up',
  delay: 100,
  threshold: 0.2,
  distance: 80
})

// Анимация для второй карточки (Touch Multi) с небольшой задержкой
const {
  elementRef: pricingCard2,
  isVisible: isVisible2,
  revealStyles: revealStyles2,
  direction: direction2
} = useScrollReveal({
  direction: 'up',
  delay: 250,
  threshold: 0.2,
  distance: 80
})
</script>

<style scoped>
/* Анимация появления карточек */
.pricing-card {
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.pricing-card.reveal-up {
  transform: translateY(var(--reveal-distance, 80px));
}

.pricing-card.is-visible {
  opacity: 1;
  transform: translateY(0);
  transition-delay: var(--reveal-delay, 0ms);
}

/* Заголовок с градиентом */
h2 {
  background: linear-gradient(100deg, #FFF 40.34%, rgba(255, 255, 255, 0.00) 135.88%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* Контейнер тарифных карточек */
.pricing-cards-container {
  /* Отступ сверху для мобильной версии */
  margin-top: -25px;
}

/* Контейнер цен - минимальный gap на мобильных */
.price-container {
  gap: 0.25rem;
  /* 4px */
  flex-wrap: nowrap;
}

/* Кнопки в столбец на мобильных */
.buttons-container {
  flex-direction: column;
  align-items: stretch !important;
  gap: 12px;
  padding-top: 44px;
}

/* Badge центрирование на мобильных */
.button-badge {
  left: 35%;
  right: auto;
  transform: translateX(-50%);
}

/* Размеры цен для мобильной версии */
.price-strikethrough {
  font-size: 19.371px;
  flex-shrink: 0;
}

.price-main {
  font-size: 30px;
  flex-shrink: 0;
}

.price-period {
  font-size: 13.719px;
  flex-shrink: 0;
}

/* Отрицательный сдвиг для десктопа */
@media (min-width: 1024px) {
  .pricing-cards-container {
    transform: translateY(-1.25rem);
    margin-top: 0;
  }

  /* Увеличенный gap для десктопа */
  .price-container {
    gap: 0.5rem;
    /* 8px */
  }

  /* Кнопки в строку на десктопе */
  .buttons-container {
    flex-direction: row;
    align-items: flex-end !important;
    padding-top: 0;
    padding-bottom: 0;
  }

  /* Badge возвращаем на место на десктопе */
  .button-badge {
    left: auto;
    right: 2rem;
    transform: none;
  }

  /* Возвращаем размеры по умолчанию для десктопа */
  .price-strikethrough {
    font-size: 1.125rem;
    /* text-lg */
  }

  .price-main {
    font-size: 2.25rem;
    /* text-4xl */
  }

  .price-period {
    font-size: 1.25rem;
    /* text-xl */
  }
}
</style>
